<placeme-layout-seo [seo]="'agenciesPage.seo' | translate">
  <placeme-jumbotron [seo]="'agenciesPage.seo' | translate"></placeme-jumbotron>

  <markdown class="page-markdown" [data]="'agenciesPage.content' | translate"></markdown>

  <section class="agences" *ngFor="let item of agencies; index as i">
    <h2 class="display">{{ item.seo.title }}</h2>
    <div class="card" [class.card--mirror]="i % 2 !== 0">
      <img class="card__map" [src]="item.address | googleMapsImage" [alt]="item.seo.title" [title]="item.seo.title" />
      <article class="card__content" [class.card--mirror__content]="i % 2 !== 0">
        <header class="card__content__content">
          <img class="card__content__content__logo" [src]="item.theme.logo.square.url" />
          <h3 class="card__content__content__title">{{ item.seo.title }}</h3>
          <p class="headline card__content__content__subtitle">{{ item.seo.description }}</p>
          <p class="card__content__content__address">{{ item.address.street }}, {{ item.address.zipcode + ' ' + item.address.city }}</p>
          <div class="card__content__content__buttons">
            <a [href]="item.contact.webSite" target="_blank" class="card__content__content__buttons__button" placeme-button>
              {{ 'agenciesPage.card.webSiteLabel' | translate }}
            </a>
          </div>
        </header>
        <footer class="card__content__footer">
          <img
            class="card__content__footer__background"
            [src]="
              item.seo
                | seoImageUrl
                  : {
                      text: false,
                      format: 'rectangle',
                      logo: true,
                      category: item.__typename
                    }
            "
            [alt]="item.seo.title"
            [title]="item.seo.title"
          />
        </footer>
      </article>
    </div>
  </section>
</placeme-layout-seo>
